import Papa from "papaparse";
import * as XLSX from "xlsx";
import OnlyHeader from "components/Headers/OnlyHeader.js";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  Input,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import cross from "../assets/img/cross.svg";
import { toast } from "react-toastify";
import { addPizzaMoneyByCsv } from "store/actions/pizzaMoneyAction";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { addPizzaMoneyBySingle } from "store/actions/pizzaMoneyAction";
import { getPizzaMoneyData } from "store/actions/pizzaMoneyAction";

const PizzaMoney = () => {
  const fileInputRef1 = useRef(null);
  let dispatch = useDispatch();
  let { uid, user } = useSelector((state) => state.auth);
  let { pizzaMoneyCsvResponse, pizzaMoney, lastDocument, hasMoreDocument } =
    useSelector((state) => state.pizzaMoney);
  const [btnLoader, setBtnLoader] = useState(false);
  const [dataLoader, setDataLoader] = useState(false);
  const [PizzaModal, setPizzaModal] = useState(false);
  const [PizzaModalCsv, setPizzaModalCsv] = useState(false);
  const [showAddFans, setShowAddFans] = useState(false);
  const [pizzaMoneyData, setPizzaMoneyData] = useState({
    athleteData: "",
  });
  const [pizzaMoneySingleData, setPizzaMoneySingleData] = useState({
    athleteId: "",
    expireDate: "",
  });
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const handleChange = (e) => {
    const { value, name } = e.target;
    setPizzaMoneySingleData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    setDataLoader(true);
    dispatch(
      getPizzaMoneyData(uid, "", () => {
        setDataLoader(false);
      })
    );
  }, []);

  const loadMore = () => {
    setIsLoadingMore(true);
    dispatch(
      getPizzaMoneyData(uid, lastDocument, () => {
        setIsLoadingMore(false);
      })
    );
  };

  const handleFile = (event) => {
    const file = event.target.files[0];
    const name = event.target.name;

    if (file) {
      const validCsvTypes = ["text/csv", "application/vnd.ms-excel"];
      const validExcelTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];

      if (validCsvTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onload = ({ target }) => {
          Papa.parse(target.result, {
            header: true,
            skipEmptyLines: true,
            complete: (result) => {
              const { data, meta } = result;
              const headers = meta.fields;
              console.log(headers, "headersheaders");

              if (
                !headers.includes("FHP_ID") ||
                !headers.includes("ENDING_DATE")
              ) {
                toast.error(
                  "CSV file must contain 'FHP_ID' and 'ENDING_DATE' headers."
                );
                return;
              }
              setPizzaMoneyData((prev) => ({
                ...prev,
                [name]: file,
              }));
            },
          });
        };
        reader.readAsText(file);
      } else if (validExcelTypes.includes(file.type)) {
        const reader = new FileReader();
        reader.onload = ({ target }) => {
          const workbook = XLSX.read(target.result, { type: "binary" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          const headers = jsonData[0];
          console.log(headers, "headersheaders");

          if (!headers.includes("FHP_ID") || !headers.includes("ENDING_DATE")) {
            toast.error(
              "Excel file must contain 'FHP_ID' and 'ENDING_DATE' headers."
            );
            return;
          }

          setPizzaMoneyData((prev) => ({
            ...prev,
            [name]: file,
          }));
        };
        reader.readAsBinaryString(file);
      } else {
        toast.error("Please select a CSV or Excel file.");
        setPizzaMoneyData((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
  };

  const handlePizzaMoney = () => {
    setPizzaModal(!PizzaModal);
  };
  const submitPizzaScv = (e) => {
    e.preventDefault();

    let data = new FormData();
    if (pizzaMoneyData.athleteData == "") {
      toast.error("Please add data in all fields");
    } else {
      setBtnLoader(true);
      data.append("athletesDetails", pizzaMoneyData.athleteData);
      data.append(
        "schoolAdminId",
        user.role == "school-sub-admin" ? user.school_admin_id : uid
      );
      dispatch(
        addPizzaMoneyByCsv(data, (res) => {
          dispatch(
            getPizzaMoneyData(uid, "", () => {
              setBtnLoader(false);
              setShowAddFans(true);
            })
          );
        })
      );
    }
  };
  const submitPizzaSingle = (e) => {
    e.preventDefault();
    setBtnLoader(true);
    let data = new FormData();
    if (
      pizzaMoneySingleData.athleteId == "" ||
      pizzaMoneySingleData.expireDate == ""
    ) {
      toast.error("Please add data in all fields");
    } else {
      data.append("athleteID", Number(pizzaMoneySingleData.athleteId));
      data.append("endingDate", pizzaMoneySingleData.expireDate);
      data.append(
        "schoolAdminId",
        user.role == "school-sub-admin" ? user.school_admin_id : uid
      );
      dispatch(
        addPizzaMoneyBySingle(data, (res) => {
          setBtnLoader(false);
          if (res == "success") {
            handlePizzaMoney();
            dispatch(
              getPizzaMoneyData(uid, "", () => {
                handlePizzaMoney();
                setPizzaMoneySingleData({
                  athleteId: "",
                  expireDate: "",
                });
              })
            );
          }
        })
      );
    }
  };
  return (
    <>
      <OnlyHeader />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center flex-sm-row flex-column gap-3">
                <h3 className="mb-0 WalletHeaderHeading text-left">
                  Pizza Money
                </h3>
                <div class="d-flex justify-content-start justify-content-md-center align-items-center mt-3 mt-sm-0 WalletHeaderActions">
                  <Button
                    color="primary"
                    onClick={() => {
                      handlePizzaMoney();
                      setPizzaModalCsv(false);
                      setPizzaMoneySingleData((prev) => ({
                        ...prev,
                        athleteId: "",
                        expireDate: "",
                      }));
                    }}
                  >
                    Import Single
                  </Button>
                  <Button
                    color="primary"
                    onClick={() => {
                      handlePizzaMoney();
                      setPizzaModalCsv(true);
                      setPizzaMoneyData((prev) => ({
                        ...prev,
                        athleteData: "",
                      }));
                    }}
                  >
                    Import CSV
                  </Button>
                </div>
              </CardHeader>
              {dataLoader ? (
                <div className="text-center my-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                      <tr>
                        <th scope="col">Athlete Name</th>
                        <th scope="col">Athlete email</th>
                        <th scope="col">Status</th>
                        <th scope="col">Created At</th>
                        <th scope="col">Expiry Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pizzaMoney?.length > 0 ? (
                        pizzaMoney?.map((items, index) => {
                          return (
                            <tr key={index}>
                              <td>{items.athleteName}</td>
                              <td>{items.athleteEmail}</td>
                              <td>{items.status}</td>
                              <td>
                                {moment
                                  .unix(items?.createdAt?.seconds)
                                  .format("DD-MM-YYYY")}
                              </td>
                              <td>
                                {moment
                                  .unix(items?.endingDate?.seconds)
                                  .format("DD-MM-YYYY")}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                          <td>N/A</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                  {pizzaMoney.length > 9 && (
                    <div className="text-center">
                      <Button
                        className="mt-2 bg-primary border-0  text-white mb-2"
                        disabled={isLoadingMore || !hasMoreDocument}
                        onClick={loadMore}
                      >
                        {isLoadingMore ? <Spinner size="sm" /> : "Load More"}
                      </Button>
                    </div>
                  )}
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={PizzaModal} toggle={handlePizzaMoney} size="xl">
        <ModalBody>
          <Form onSubmit={PizzaModalCsv ? submitPizzaScv : submitPizzaSingle}>
            <Container>
              <h1 className="text-center mb-4">Add Pizza money Data</h1>
              <Row className="d-flex justify-content-center">
                {PizzaModalCsv ? (
                  <>
                    <Col
                      md="12"
                      className="d-flex align-items-center justify-content-center flex-column"
                    >
                      <label htmlFor="file" className="btn btn-primary">
                        Choose athlete data file
                      </label>
                      <input
                        placeholder="select file"
                        type="file"
                        id="file"
                        name="athleteData"
                        ref={fileInputRef1}
                        className="d-none"
                        accept=".csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        onChange={handleFile}
                        required
                      />
                      {pizzaMoneyData.athleteData?.name && (
                        <div className="position-relative mt-2">
                          <img
                            src={cross}
                            width={20}
                            alt=""
                            className="position-absolute"
                            style={{
                              top: "-11%",
                              left: "100%",
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setPizzaMoneyData((prev) => ({
                                ...prev,
                                athleteData: "",
                              }));
                              fileInputRef1.current.value = "";
                            }}
                          />
                          <p className="mt-2">
                            {pizzaMoneyData.athleteData?.name}
                          </p>
                        </div>
                      )}
                    </Col>
                    {showAddFans && (
                      <div>
                        <h1 className="text-center mt-4">
                          {pizzaMoneyCsvResponse?.inValidAthletes?.length > 0
                            ? "Rejected pizza Money Requests"
                            : "Pizza Money Successfully"}
                        </h1>

                        {pizzaMoneyCsvResponse?.inValidAthletes?.length > 0 && (
                          <Table
                            className="align-items-center table-flush mt-3"
                            responsive
                          >
                            <thead className="thead-light">
                              <tr>
                                <th scope="col">ATHLETE ID</th>
                              </tr>
                            </thead>
                            <tbody>
                              {pizzaMoneyCsvResponse?.inValidAthletes?.length >
                              0 ? (
                                pizzaMoneyCsvResponse?.inValidAthletes?.map(
                                  (items) => {
                                    return (
                                      <tr key={items.FHP_ID}>
                                        <td>{items?.FHP_ID}</td>
                                      </tr>
                                    );
                                  }
                                )
                              ) : (
                                <tr>
                                  <td>N/A</td>
                                  <td>N/A</td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        )}
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    <Col md="3">
                      <Input
                        placeholder="Enter Athlete Id"
                        type="number"
                        name="athleteId"
                        onChange={handleChange}
                        value={pizzaMoneySingleData.athleteId}
                        required
                      />
                    </Col>
                    <Col md="3">
                      <Input
                        placeholder="Enter Date"
                        type="date"
                        name="expireDate"
                        min={moment().format("YYYY-MM-DD")}
                        onChange={handleChange}
                        value={pizzaMoneySingleData.expireDate}
                        required
                      />
                    </Col>
                  </>
                )}
              </Row>
            </Container>
            <div className="text-right mt-4">
              <Button onClick={handlePizzaMoney}>Cancel</Button>
              <Button color="primary" type="submit" disabled={btnLoader}>
                {btnLoader ? <Spinner size="sm" /> : "Submit"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default PizzaMoney;
